import React from 'react';
import PropTypes from 'prop-types';

import {
	makeStyles,
	Grid,
	Paper
} from '@material-ui/core';

import Heading from "./Heading";
import ActivityAuditTrail from "./ActivityAuditTrail";
import UserActivityIndicators from "./UserActivityIndicators";

const styles = makeStyles(theme => ({
	headerGrid: {
		marginBottom: theme.spacing(0.5)
	},
	paper: {
		padding: theme.spacing(2.5),
		borderRadius: "15px",
		margin: theme.spacing(1),
		border: `1px solid ${theme.palette.secondary.lightGrey}`
	},
}));

function UserActivityTrail(props) {
	let classes = styles(),
		{className, fidoError, auditTrail,
			shared, saved, removed, rated, viewed, category} = props;

	return (
		<Paper className={`${classes.paper} ${className}`}>
			<Grid
				container
				justify="space-between"
				className={classes.headerGrid}>
				<Grid item>
					<Heading title="Team Actions" />
				</Grid>
				<Grid item>
					<UserActivityIndicators
						rated={rated}
						viewed={viewed} />
				</Grid>
			</Grid>
			<ActivityAuditTrail
				category={category}
				userActivity={auditTrail}
				fidoError={fidoError} />
		</Paper>
	);
}

UserActivityTrail.propTypes = {
	fidoError: PropTypes.bool,
	className: PropTypes.string,
	shared: PropTypes.array,
	saved: PropTypes.array,
	removed: PropTypes.array,
	rated: PropTypes.array,
	viewed: PropTypes.array,
	auditTrail: PropTypes.array,
	category: PropTypes.number
};

export default UserActivityTrail;
